// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-close-ykL_Vp{cursor:pointer;background-color:#1d1c23;border-radius:32px;justify-content:center;align-items:center;padding:4px;display:flex;position:absolute;top:-6px;right:-6px;box-shadow:0 4px 6px rgba(0,0,0,.1),0 0 1px rgba(0,0,0,.3)}.icon-close-ykL_Vp svg{width:12px;height:12px}.icon-close-ykL_Vp svg path{color:#fff}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon-close": `icon-close-ykL_Vp`,
	"iconClose": `icon-close-ykL_Vp`
};
export default ___CSS_LOADER_EXPORT___;
